import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Subscriber } from '../../Subscriber';
import './SubscriberLink.scss';
export const SubscriberLink = ({ className, href, title, children, negative = false, rejectionTitle = 'Krever abonnement' }) => {
    const clsxEligible = [
        'subscriber-link',
        'eligible',
        className !== null && className !== void 0 ? className : '',
        negative ? 'negative' : ''
    ].join(' ');
    const clsxNotEligible = [
        'subscriber-link',
        'not-eligible',
        className !== null && className !== void 0 ? className : '',
        negative ? 'negative' : ''
    ].join(' ');
    return (_jsxs(Subscriber, { children: [_jsx(Subscriber.Eligible, { children: _jsx("a", { className: clsxEligible, title: title ? title : '', href: href, children: _jsx("span", { children: children }) }) }), _jsx(Subscriber.NotEligible, { children: _jsx("span", { className: clsxEligible, title: rejectionTitle, children: children }) })] }));
};
